<template>
  <div>
    <h2 class="configure-title">
      <svg>
        <use v-bind="{'xlink:href':'#settings-icon'}" />
      </svg>
      Configure
    </h2>
    <div class="webhook-wrapper">
      <div class="webhook-content" style="display: block;">
        <template v-for="(ep, index) in localEndpoints" :key="index">
          <h3>Endpoint {{ index + 1 }}</h3>
          <div class="webhook__endpoint-wrapper">
            <input
              :class="'endpoint' + (index + 1)"
              type="text"
              v-model="localEndpoints[index]"
              placeholder="https://yoursite.com/widget-endpoint"
            >
            <button
              v-if="localEndpoints.length > 1"
              class="remove-endpoint"
              @click="removeEndpoint(index)"
            >
              <svg class="edit">
                <use v-bind="{'xlink:href':'#delete-icon'}" />
              </svg>
            </button>
          </div>
        </template>
        <button
          v-if="localEndpoints.length < 5"
          @click="addEndpoint()"
          class="add-endpoint"
        >Add another endpoint</button>
        <p v-if="error" class="error-message">{{ error }}</p>
        <div class="queries-wrapper">
          <button
            class="btn-style-common medium outlined"
            @click="$emit('cancel')"
          >Cancel</button>
          <button
            class="btn-style-common medium"
            :disabled="loading"
            @click="$emit('save', filteredEndpoints)"
          >{{ buttonLabel }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetEndpoints',
  props: {
    endpoints: { type: Array, default: () => [''] },
    loading: { type: Boolean, default: false },
    error: { type: String, default: '' },
    hasAccessKey: { type: Boolean, default: false },
  },
  data() {
    return {
      localEndpoints: [...this.endpoints],
    };
  },
  computed: {
    buttonLabel() {
      if (this.loading) return 'Saving...';
      return this.hasAccessKey
        ? 'Save'
        : 'Save & Generate Public Key';
    },
    filteredEndpoints() {
      return this.localEndpoints
        .filter((ep) => ep.trim() !== '');
    },
  },
  watch: {
    endpoints(val) {
      this.localEndpoints = [...val];
    },
  },
  methods: {
    addEndpoint() {
      if (this.localEndpoints.length < 5) {
        this.localEndpoints.push('');
      }
    },
    removeEndpoint(index) {
      if (this.localEndpoints.length > 1) {
        this.localEndpoints.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.configure-title {
  @include font-styles($type: 'text', $size: 'lg', $weight: 'bold');
  padding-bottom: size(14);
  display: inline-block;

  svg {
    display: inline-block;
    vertical-align: middle;
    width: size(23);
    height: size(21);
    margin-right: size(10);
  }
}

.webhook-wrapper {
  .webhook__endpoint-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: size(10);

    input {
      @include font-styles($type: 'label', $size: 'lg', $weight: 'regular');
      width: 100%;
      padding: size(10) size(14);
      border: size(1) solid var(--global--border--Color);
      border-radius: size(4);
      outline: none;

      &:focus {
        border-color: var(--global--common-link--Color);
      }
    }

    .remove-endpoint {
      cursor: pointer;
      margin-left: size(10);
      background: none;
      border: none;
      padding: size(5);

      svg {
        width: size(16);
        height: size(16);
        fill: var(--global--main-title--Color);
      }
    }
  }

  .webhook-content {
    background: var(--global--white--Color);
    box-shadow: 0 size(1) size(3) rgba(0, 0, 0, 0.1),
      0 size(2) size(1) rgba(0, 0, 0, 0.06),
      0 size(1) size(1) rgba(0, 0, 0, 0.08);
    border-radius: size(8);
    padding: size(20);

    h3 {
      @include font-styles($type: 'label', $size: 'lg', $weight: 'bold');
      padding-bottom: size(6);
      padding-top: size(10);

      &:first-child {
        padding-top: 0;
      }
    }
  }
}

.add-endpoint {
  @include font-styles($type: 'label', $size: 'lg', $weight: 'bold');
  color: var(--global--common-link--Color);
  cursor: pointer;
  padding: size(10) 0;
  background: none;
  border: none;
}

.error-message {
  color: var(--global--error--BackgroundColor);
  @include font-styles($type: 'label', $size: 'lg', $weight: 'regular');
  padding-top: size(10);
}

.queries-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: size(10);
  padding-top: size(20);
}
</style>
